<template>
	<div v-if="isEboekhoudenEnabled || isMoneybirdEnabled || isModuleInvoiceEnabled">
		<vx-card title="Facturen" class="text-md" noShadow cardBorder>

			<e-boekhouden :order="order" v-if="isEboekhoudenEnabled"/>

			<hr class="mt-5" v-if="isEboekhoudenEnabled && isMoneybirdEnabled"/>

			<moneybird :order="order" v-if="isMoneybirdEnabled"/>

			<hr class="mt-5" v-if="isMoneybirdEnabled && isModuleInvoiceEnabled"/>
			<hr class="mt-5" v-if="isEboekhoudenEnabled && !isMoneybirdEnabled && isModuleInvoiceEnabled"/>

			<module-invoice :order="order" v-if="isModuleInvoiceEnabled"/>
		</vx-card>

	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import EBoekhouden from '@/views/orderDetails/invoice/eBoekhouden';
import Moneybird from '@/views/orderDetails/invoice/moneybird';
import ModuleInvoice from "@/views/orderDetails/invoice/moduleInvoice.vue";

export default {
	components: {
		ModuleInvoice,
		Moneybird,
		EBoekhouden
	},
	props: {
		order: {
			required: true,
		}
	},
	computed: {
		...mapGetters({
			isEboekhoudenEnabled: 'dashboard/eboekhoudenEnabled',
			isMoneybirdEnabled: 'dashboard/moneybirdEnabled',
			isModuleInvoiceEnabled: 'dashboard/moduleInvoiceEnabled',
		}),
	}
}
</script>
